// EOD Summary Report (ClickHouse) — powers the "Summary Report" table on the
// EOD Reconciliation screen. Server-paginated and server-sorted.
export const FETCH_EOD_SUMMARY_REPORT_REQUEST = 'reports/eodClickhouse/FETCH_EOD_SUMMARY_REPORT_REQUEST';
export const FETCH_EOD_SUMMARY_REPORT_SUCCESS = 'reports/eodClickhouse/FETCH_EOD_SUMMARY_REPORT_SUCCESS';
export const FETCH_EOD_SUMMARY_REPORT_FAILURE = 'reports/eodClickhouse/FETCH_EOD_SUMMARY_REPORT_FAILURE';

// EOD Funds table (ClickHouse) — the SAME `sales/live/v2/eodSummaryReport`
// endpoint, read for `businessDate` / `creditSales` / `maghilFunding`. It gets
// its own action triple because it lives on the same screen as the Summary
// Report table with independent page / size / sort state; sharing one action
// would make each table's fetch clobber the other's rows.
export const FETCH_EOD_FUNDS_REPORT_REQUEST = 'reports/eodClickhouse/FETCH_EOD_FUNDS_REPORT_REQUEST';
export const FETCH_EOD_FUNDS_REPORT_SUCCESS = 'reports/eodClickhouse/FETCH_EOD_FUNDS_REPORT_SUCCESS';
export const FETCH_EOD_FUNDS_REPORT_FAILURE = 'reports/eodClickhouse/FETCH_EOD_FUNDS_REPORT_FAILURE';
